import _toConsumableArray from "/opt/atlassian/pipelines/agent/build/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _slicedToArray from "/opt/atlassian/pipelines/agent/build/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _asyncToGenerator from "/opt/atlassian/pipelines/agent/build/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import { defineComponent, ref, watch, onMounted, onUnmounted, nextTick } from "vue"; // modules

import POSConfigModule from "@/store/modules/pos-config";
import { PCTypes } from "@/types/db/product-category";
import { getProductCategoriesWithPricesArray, getProductCategoriesWithFlatPrice } from "@/utils/helpers/product-category";
import { getAllTimeSlotsByProductCategory, getFutureTimeSlotsByProductCategory } from "@/utils/helpers/timeslots";
import { recordOperationDuration } from "@/utils/vue-helpers/common";
import { useIntersectionObserver } from "@vueuse/core";
import { LogService } from "@/services/logging";
import { PRODUCT_CATEGORY_PAGINATION_LIMIT } from "@/constants/app";
export default defineComponent({
  name: "TicketsGrid",
  props: {
    ticketGroupId: {
      type: Number,
      required: true
    }
  },
  components: {},
  setup: function setup(props) {
    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
      var loading, selectedConfig, productCards, keys, groupedProducts, didScroll, productsCount, noMoreProducts, loadTrigger, isLoadingProducts, intersectionObserverCleanup, sortProductCategories, _sortProductCategories, handleScroll, handleTouchStart, loadProducts, _loadProducts, resetState, setupIntersectionObserver;

      return regeneratorRuntime.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              setupIntersectionObserver = function _setupIntersectionObs() {
                // clean up previous observer if exists
                if (intersectionObserverCleanup) {
                  intersectionObserverCleanup();
                  intersectionObserverCleanup = null;
                } // set up new observer


                var _useIntersectionObser = useIntersectionObserver(loadTrigger, /*#__PURE__*/function () {
                  var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(_ref) {
                    var _ref3, isIntersecting, operationStartTime, operationEndTime, operationDuration;

                    return regeneratorRuntime.wrap(function _callee$(_context) {
                      while (1) {
                        switch (_context.prev = _context.next) {
                          case 0:
                            _ref3 = _slicedToArray(_ref, 1), isIntersecting = _ref3[0].isIntersecting;

                            if (!(isIntersecting && !isLoadingProducts.value)) {
                              _context.next = 16;
                              break;
                            }

                            operationStartTime = performance.now();
                            _context.prev = 3;
                            _context.next = 6;
                            return loadProducts();

                          case 6:
                            _context.next = 11;
                            break;

                          case 8:
                            _context.prev = 8;
                            _context.t0 = _context["catch"](3);
                            LogService.info("Error in intersection observer callback", {
                              params: {
                                ticketGroupId: props.ticketGroupId
                              },
                              error: _context.t0
                            });

                          case 11:
                            _context.prev = 11;
                            operationEndTime = performance.now();
                            operationDuration = operationEndTime - operationStartTime;
                            recordOperationDuration("TicketsGrid_refresh for ticketGroupId: ".concat(props.ticketGroupId), operationDuration);
                            return _context.finish(11);

                          case 16:
                          case "end":
                            return _context.stop();
                        }
                      }
                    }, _callee, null, [[3, 8, 11, 16]]);
                  }));

                  return function (_x2) {
                    return _ref2.apply(this, arguments);
                  };
                }()),
                    stop = _useIntersectionObser.stop;

                intersectionObserverCleanup = stop;
              };

              resetState = function _resetState() {
                productsCount.value = 0;
                noMoreProducts.value = false;
                isLoadingProducts.value = false;
                productCards.value = [];
                keys.value = [];
                groupedProducts.value = {};
              };

              _loadProducts = function _loadProducts3() {
                _loadProducts = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
                  var newCards, newProductsCount, isSeparatedButtons, t1, _yield$getProductCate, cards, pcCount, duration;

                  return regeneratorRuntime.wrap(function _callee4$(_context4) {
                    while (1) {
                      switch (_context4.prev = _context4.next) {
                        case 0:
                          if (!(isLoadingProducts.value || noMoreProducts.value)) {
                            _context4.next = 2;
                            break;
                          }

                          return _context4.abrupt("return");

                        case 2:
                          isLoadingProducts.value = true;
                          _context4.prev = 3;
                          newCards = null;
                          newProductsCount = 0;
                          isSeparatedButtons = POSConfigModule.isSeperatedButtons;
                          t1 = performance.now();

                          if (isSeparatedButtons) {
                            _context4.next = 15;
                            break;
                          }

                          _context4.next = 11;
                          return getProductCategoriesWithPricesArray(props.ticketGroupId, productsCount.value);

                        case 11:
                          newCards = _context4.sent;
                          newProductsCount = newCards.length;
                          _context4.next = 22;
                          break;

                        case 15:
                          _context4.next = 17;
                          return getProductCategoriesWithFlatPrice(props.ticketGroupId, productsCount.value);

                        case 17:
                          _yield$getProductCate = _context4.sent;
                          cards = _yield$getProductCate.cards;
                          pcCount = _yield$getProductCate.pcCount;
                          newCards = cards;
                          newProductsCount = pcCount;

                        case 22:
                          duration = performance.now() - t1;
                          console.log("loadProducts for ticketGroupId: ".concat(props.ticketGroupId, " took ").concat(duration / 1000, " s"));
                          recordOperationDuration("loadProducts for ticketGroupId: ".concat(props.ticketGroupId), duration);

                          if (newProductsCount) {
                            _context4.next = 29;
                            break;
                          }

                          // no new products were fetched
                          noMoreProducts.value = true;
                          isLoadingProducts.value = false;
                          return _context4.abrupt("return");

                        case 29:
                          productsCount.value += newProductsCount;
                          productCards.value = [].concat(_toConsumableArray(productCards.value || []), _toConsumableArray(newCards || [])); // Seating plan logic:
                          // from productCards exclude any recurring seating plan since it shouldn't be shown in a alphabetic grid, it should be shown in a calendar

                          productCards.value = productCards.value.filter(function (pc) {
                            return !pc.isReccuringSeating;
                          });
                          newCards = newCards.filter(function (pc) {
                            return !pc.isReccuringSeating;
                          });
                          t1 = performance.now();
                          _context4.next = 36;
                          return sortProductCategories(newCards);

                        case 36:
                          duration = performance.now() - t1;
                          console.log("sortProductCategories for ticketGroupId: ".concat(props.ticketGroupId, " took ").concat(duration / 1000, " s."));
                          recordOperationDuration("sortProductCategories for ticketGroupId: ".concat(props.ticketGroupId), duration); // update cards list and the count index

                          if (!newProductsCount || newProductsCount < PRODUCT_CATEGORY_PAGINATION_LIMIT) {
                            // No more products in db
                            // Let's update noMoreProducts to hide the loader element
                            noMoreProducts.value = true;
                          }

                          _context4.next = 45;
                          break;

                        case 42:
                          _context4.prev = 42;
                          _context4.t0 = _context4["catch"](3);
                          LogService.info("Error when fetching products from indexedDB", _context4.t0);

                        case 45:
                          _context4.prev = 45;
                          isLoadingProducts.value = false;
                          return _context4.finish(45);

                        case 48:
                        case "end":
                          return _context4.stop();
                      }
                    }
                  }, _callee4, null, [[3, 42, 45, 48]]);
                }));
                return _loadProducts.apply(this, arguments);
              };

              loadProducts = function _loadProducts2() {
                return _loadProducts.apply(this, arguments);
              };

              handleTouchStart = function _handleTouchStart(e) {
                didScroll.value = false;
              };

              handleScroll = function _handleScroll(e) {
                didScroll.value = true;
              };

              _sortProductCategories = function _sortProductCategorie2() {
                _sortProductCategories = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(sortedProductCards) {
                  var now, i, timeslots, _i, letter;

                  return regeneratorRuntime.wrap(function _callee3$(_context3) {
                    while (1) {
                      switch (_context3.prev = _context3.next) {
                        case 0:
                          if (!(!sortedProductCards || !sortedProductCards.length)) {
                            _context3.next = 2;
                            break;
                          }

                          return _context3.abrupt("return");

                        case 2:
                          // 2- Add timeslots data to the product Availability/StartDateTime/EndDateTime OR get retail-option data if it is a retail product
                          now = new Date().toISOString();
                          i = 0;

                        case 4:
                          if (!(i < sortedProductCards.length)) {
                            _context3.next = 21;
                            break;
                          }

                          if (!(sortedProductCards[i].type === PCTypes[PCTypes.Retail])) {
                            _context3.next = 7;
                            break;
                          }

                          return _context3.abrupt("continue", 18);

                        case 7:
                          if (!(sortedProductCards[i].type === PCTypes[PCTypes.Seated])) {
                            _context3.next = 13;
                            break;
                          }

                          _context3.next = 10;
                          return getAllTimeSlotsByProductCategory(Number(sortedProductCards[i].productCategoryId), 1);

                        case 10:
                          _context3.t0 = _context3.sent;
                          _context3.next = 16;
                          break;

                        case 13:
                          _context3.next = 15;
                          return getFutureTimeSlotsByProductCategory(Number(sortedProductCards[i].productCategoryId), now, 1);

                        case 15:
                          _context3.t0 = _context3.sent;

                        case 16:
                          timeslots = _context3.t0;

                          if (timeslots && timeslots.length) {
                            // In case of a none-reccuring seating plan we are taking dbAvailability from childrenPSC.resource.quantity, and it seems this field actually has the total quantity
                            // we need to substract what was already booked from it which we can get from timeslots[0].booked
                            // TODO Hamza: One Concept to Discuss with the Team:
                            // a. None Reccuring Seating Quantity resides in childPSC.resource.quantity
                            // b. Already booked seats number resides in timeslots[0].booked
                            // c. Now we are deducting what was already booked from total quantity, but the user is still able to go to seats io and make seats available for sales, in this case POS will not know this, how we should handle this case? And did we actually have users who went to seats io and made sold seats available again?
                            if (sortedProductCards[i].type === PCTypes[PCTypes.Seated] && !sortedProductCards[i].isReccuringSeating) {
                              if (!sortedProductCards[i].dbAvailability) {
                                sortedProductCards[i].dbAvailability = 0;
                              } else {
                                sortedProductCards[i].dbAvailability = Number(sortedProductCards[i].dbAvailability) - timeslots[0].booked;
                                sortedProductCards[i].booked = timeslots[0].booked;
                              }
                            } else {
                              sortedProductCards[i].dbAvailability = timeslots[0].availability;
                            }

                            sortedProductCards[i].startDateTime = timeslots[0].startDateTime;
                            sortedProductCards[i].endDateTime = timeslots[0].endDateTime;
                            sortedProductCards[i].timeslot_ID = timeslots[0]._id;
                            sortedProductCards[i].booked = timeslots[0].booked; // TODO Hamza: Reccuring Seating Plan logic
                            // Check if pc.type = 3 and pc.isParentReccuringSeating = 1 then we assign sortedProductCards[i].eventKey = timeslots[0].eventKey

                            if (sortedProductCards[i].type === PCTypes[PCTypes.Seated] && sortedProductCards[i].isReccuringSeating) {
                              // Since the card is holding a reccuring seating plan sub-category then we will ignore eventKey value coming from parentCategory
                              // and consider the eventKey that resides inside Timeslot entity
                              sortedProductCards[i].eventKey = timeslots[0].eventKey;
                            }
                          }

                        case 18:
                          i++;
                          _context3.next = 4;
                          break;

                        case 21:
                          // 3- Group productCategories by alphabet
                          for (_i = 0; _i < sortedProductCards.length; _i++) {
                            letter = String(sortedProductCards[_i].categoryName)[0].toUpperCase(); // lets check if this record has product categories of this letter

                            if (!groupedProducts.value || groupedProducts.value[letter]) {
                              // so this letter has a record already, lets add the currect product category to this record
                              groupedProducts.value[letter].push(sortedProductCards[_i]);
                            } else {
                              // so the record does not have product categries of this letter, lets add it
                              groupedProducts.value[letter] = [sortedProductCards[_i]];
                            }
                          }

                          keys.value = Object.keys(groupedProducts.value); // console.log("returning");
                          // console.log(groupedProducts.value);

                          return _context3.abrupt("return", groupedProducts.value);

                        case 24:
                        case "end":
                          return _context3.stop();
                      }
                    }
                  }, _callee3);
                }));
                return _sortProductCategories.apply(this, arguments);
              };

              sortProductCategories = function _sortProductCategorie(_x) {
                return _sortProductCategories.apply(this, arguments);
              };

              loading = ref(false);
              selectedConfig = ref(POSConfigModule.selectedConfig); // Get product categories from local db

              productCards = ref([]); //  keys are the alphabets the user sees grouping the ProductCategories

              keys = ref(); // initiating a the variable with an empty object, cast it to be Record type, and make it reactive

              groupedProducts = ref({});
              didScroll = ref(false); // used for pagination when fetching PCs from indexedDB

              productsCount = ref(0);
              noMoreProducts = ref(false);
              loadTrigger = ref();
              isLoadingProducts = ref(false);
              intersectionObserverCleanup = null;
              /**
               * Sort product categories alphabetically, then group them by alphabet
               */

              // watch for ticketGroupId changes and reset/reload
              watch(function () {
                return props.ticketGroupId;
              }, /*#__PURE__*/function () {
                var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(newId, oldId) {
                  var operationStartTime, operationEndTime, operationDuration;
                  return regeneratorRuntime.wrap(function _callee2$(_context2) {
                    while (1) {
                      switch (_context2.prev = _context2.next) {
                        case 0:
                          if (!(newId && newId !== oldId)) {
                            _context2.next = 20;
                            break;
                          }

                          resetState();
                          setupIntersectionObserver(); // force initial load after state reset

                          _context2.next = 5;
                          return nextTick();

                        case 5:
                          if (!(!isLoadingProducts.value && !noMoreProducts.value)) {
                            _context2.next = 20;
                            break;
                          }

                          operationStartTime = performance.now();
                          _context2.prev = 7;
                          _context2.next = 10;
                          return loadProducts();

                        case 10:
                          _context2.next = 15;
                          break;

                        case 12:
                          _context2.prev = 12;
                          _context2.t0 = _context2["catch"](7);
                          LogService.info("TicketsGrid: Error during initial load", {
                            params: {
                              ticketGroupId: props.ticketGroupId
                            },
                            error: _context2.t0
                          });

                        case 15:
                          _context2.prev = 15;
                          operationEndTime = performance.now();
                          operationDuration = operationEndTime - operationStartTime;
                          recordOperationDuration("TicketsGrid initial_load for ticketGroupId: ".concat(props.ticketGroupId), operationDuration);
                          return _context2.finish(15);

                        case 20:
                        case "end":
                          return _context2.stop();
                      }
                    }
                  }, _callee2, null, [[7, 12, 15, 20]]);
                }));

                return function (_x3, _x4) {
                  return _ref4.apply(this, arguments);
                };
              }(), {
                immediate: true
              });
              onMounted(function () {
                setupIntersectionObserver();
              });
              onUnmounted(function () {
                if (intersectionObserverCleanup) {
                  intersectionObserverCleanup();
                }
              });
              return _context5.abrupt("return", {
                selectedConfig: selectedConfig,
                loading: loading,
                productCards: productCards,
                keys: keys,
                groupedProducts: groupedProducts,
                sortProductCategories: sortProductCategories,
                // sumArray,
                getProductCategoriesWithPricesArray: getProductCategoriesWithPricesArray,
                getProductCategoriesWithFlatPrice: getProductCategoriesWithFlatPrice,
                didScroll: didScroll,
                handleScroll: handleScroll,
                handleTouchStart: handleTouchStart,
                loadProducts: loadProducts,
                loadTrigger: loadTrigger,
                isLoadingProducts: isLoadingProducts,
                noMoreProducts: noMoreProducts
              });

            case 23:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5);
    }))();
  }
});